'use client';

import * as React from 'react';

/**
 * @useClient
 */
export const SignOut = React.memo(function SignOut() {
  return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" fill="none" viewBox="0 0 18 20">
      <g>
        <path fill="#868687" d="M11 0v2H4a2 2 0 00-1.995 1.85L2 4v12a2 2 0 001.85 1.994L4 18h7v2H4a4 4 0 01-3.995-3.8L0 16V4A4 4 0 013.8.005L4 0h7zm2.613 5.21l.094.083 4 4a1 1 0 01.083 1.32l-.083.094-4 4a1 1 0 01-1.497-1.32l.083-.094L14.583 11H7a1 1 0 01-.117-1.993L7 9h7.585l-2.292-2.293a1 1 0 01-.083-1.32l.083-.094a1 1 0 011.32-.083z"></path>
      </g>
    </svg>;
});